<template>
  <div
    v-if="hiddenSections.length > 0 && $can('manage_settings')"
    class="flex flex-wrap items-center gap-2 px-4 py-3"
  >
    <span class="text-xs text-gray-400">
      {{ $t('global.hidden_sections') }} :
    </span>
    <button
      v-for="section in hiddenSections"
      :key="section.key"
      class="flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs text-gray-500 shadow-sm transition hover:border-indigo-300 hover:text-indigo-600"
      @click="toggleSectionVisibility(section.key)"
    >
      <FontAwesomeIcon :icon="['fal', 'eye']" class="text-[11px]" />
      {{ $t(section.label) }}
    </button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'HiddenSectionChips',
  components: { FontAwesomeIcon },
  inject: ['toggleSectionVisibility'],
  props: {
    hiddenSections: {
      type: Array,
      required: true,
    },
  },
}
</script>
